
import { computed, defineComponent } from 'vue'
import GreetingCard from '@/components/GreetingCard.vue'
import RedpackInfoSymbol from '../RedpackInfoSymbol.vue'

export default defineComponent({
  components: {
    GreetingCard,
    RedpackInfoSymbol
  },

  props: {
    redPackBasicInfo: {
      type: Object,
      required: true
    },
    skinImage: String
  },

  setup (props) {
    const isNoCreatorView = computed(() => {
      return !!props.redPackBasicInfo.myReward || [1, 2].includes(props.redPackBasicInfo.status)
    })

    return {
      isNoCreatorView
    }
  }
})
